export const register = () => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker
      .register('/firebase-messaging-sw.js')
      .catch((error) => {
        console.error('Error registering service worker:', error);
      });
  }
};